module.exports = __webpack_public_path__ + "static/media/spread.d49692c9.svg";